import {
  reactQueryGet,
  reactQueryPatch,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { ChecklistData } from "@/react/types";

const show = () =>
  reactQueryGet<ChecklistData>(internalApi.communities.checklist.show());

const update = (params: Partial<ChecklistData>) =>
  reactQueryPatch<ChecklistData, { checklist: Partial<ChecklistData> }>(
    internalApi.communities.checklist.update(),
    { checklist: params },
  );

export const checklistsApi = {
  show,
  update,
};
